import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

export default function OurBenefits() {
  return (
    <>
      <section className="relative py-32 overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute proBoxing inset-0 z-0"
          style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="absolute inset-0"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex justify-end">
            {/* Benefits Content */}
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="md:w-1/2 md:mt-0 mt-32 text-white bg-white p-6"
            >
              <h2 className="text-5xl text-black font-bold mb-6">OUR BENEFITS</h2>
              <p className="text-xl mb-8 text-black">
                iFLO Pro is a smart automated device that dispenses bio-enzymatic cleaner on a custom schedule to prevent biogenic bacteria (white slime, mucus, etc.) from clogging your customers' drain lines. KNOCK-OUT the competition with improved customer satisfaction guaranteed!
              </p>
              <div className="flex gap-4">
                <motion.a 
                  href="/about"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-white border border-black text-black px-6 py-2 rounded font-semibold"
                >
                  About Us
                </motion.a>
                <motion.a 
                  href="/why-iflo"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-white border border-black text-black px-6 py-2 rounded font-semibold"
                >
                  How It Works
                </motion.a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
}
